import script from "./ImageTextItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageTextItem.vue?vue&type=script&setup=true&lang=ts"

import "./ImageTextItem.vue?vue&type=style&index=0&id=1b5bbd12&lang=scss"

const __exports__ = script;

export default __exports__